import type { FaireProductEntity } from "../../entity_types/product";

export const p_9co6j9cnw7: FaireProductEntity = {
  token: "p_9co6j9cnw7",
  type: "product",
  name: "PALISADES",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/53d012cf6d76f5b8cf288a076c649f12d4c2217e23739b9ef5d9cda085c19099.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6dd2989d7a4a44c78042ad24f6ccc2368b4c0109416f1c6d139dde9da136da11.jpeg",
  ],
  priceDollars: 18,
  description:
    "A gorgeous blend of honeyed florals that open with the heady presence of freshly bloomed tuberose and gardenia. Softened with undertones of white woods and a cooling aquatic accord, capturing the essence of its namesake.\n\ntuberose, gardenia, tree flower, ambergris, white woods\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n7 ounces (198g), comes in our signature pink box.",
  tags: [],
  msrpDollars: 36,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-26T14:47:18.353Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
